/* RESPONSIBLE TEAM: team-proactive-support */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import { buildValidations, validator } from 'ember-cp-validations';

export default buildValidations({
  bodyBlocks: {
    description: 'Localized push body',
    validators: [
      validator('presence', {
        presence: true,
        message: 'Body should not be empty',
        dependentKeys: ['model.bodyBlocks.@each'],
      }),
      validator('title-and-body-blocks-not-empty', {
        message: 'Mobile Push body should not be empty',
      }),
    ],
  },
  titleBlocks: {
    description: 'Localized push title',
    validators: [
      validator('presence', {
        presence: true,
        message: 'Title should not be empty',
        dependentKeys: ['model.titleBlocks.@each'],
      }),
      validator('title-and-body-blocks-not-empty', {
        message: 'Mobile Push title should not be empty',
      }),
    ],
  },
});
